export const PRODUCT_ERROR = "product/error";
export const PRODUCT_REQUEST = "product/request";
export const PRODUCT_SUCCESS = "product/success";
